














































































































import Vue from 'vue';
import _ from 'lodash';
import TextHighlight from 'vue-text-highlight';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';

import CustomDialog from '../CustomDialog.vue';
import ThePacientesAvisosTabela from './ThePacientesAvisosTabela.vue';
import ThePacientesResumo from './ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from './ThePacientesObservacoesAlert.vue';
import { gruposIds } from '../../utils/constants';

export default Vue.extend({
  name: 'ThePacientesTabela',
  components: {
    CustomDialog,
    ThePacientesAvisosTabela,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
    TextHighlight,
  },
  props: {
    tipo: {
      type: String,
      default: '',
    },
    lastSearch: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: {
        table: true,
        usuarios: true,
      },
      options: {
        itemsPerPage: 30,
        sortBy: ['created'],
        sortDesc: [true],
      },
      totalRegistros: 0,
      filtroResponsavelId: null,
      usuarios: [],
      dialogResumoPaciente: false,
      dialogNovaPaciente: false,
      pacientes: [] as Paciente[],
      pacienteSelecionada: {} as Paciente,
    };
  },
  computed: {
    headers() {
      if (this.tipo === 'particular') {
        return [
          {
            value: 'nome',
            text: 'Nome ',
            sortable: true,
          },
          {
            value: 'responsavel_id',
            text: 'Responsável ',
            sortable: true,
          },
          {
            value: 'telefone1',
            text: 'Telefone',
            sortable: false,
            align: 'center',
          },
          {
            value: 'created',
            text: 'Cadastrada em ',
            sortable: true,
            align: 'center',
          },
          {
            value: 'avisos',
            text: 'Avisos',
            sortable: false,
            align: 'center',
          },
          {
            value: 'actions',
            text: 'Ações ',
            sortable: false,
            width: 0,
            align: 'center',
          },
        ];
      }
      return [
        {
          value: 'nome',
          text: 'Nome ',
          sortable: true,
        },
        {
          value: 'telefone1',
          text: 'Telefone',
          sortable: false,
          align: 'center',
        },
        {
          value: 'created',
          text: 'Cadastrada em ',
          sortable: true,
          align: 'center',
        },
        {
          value: 'avisos',
          text: 'Avisos',
          sortable: false,
          align: 'center',
        },
        {
          value: 'actions',
          text: 'Ações ',
          sortable: false,
          width: 0,
          align: 'center',
        },
      ];
    },
    numPaginas() {
      if (this.totalRegistros === 0) {
        return 1;
      }
      return Math.ceil(this.totalRegistros / this.options.itemsPerPage);
    },
    usuariosItens() {
      return _.orderBy(
        _.map(_.filter(this.usuarios, usuario => !usuario.email.includes('@kemiocode')),
          usuario => ({ value: usuario.id, text: usuario.nome })),
        ['text'],
      );
    },
  },
  mounted() {
    // this.carregaNovaPagina(this.search);
    if (this.tipo === 'particular') {
      this.buscaUsuarios();
    }
  },
  methods: {
    clickRow(paciente: Paciente): void {
      this.pacienteSelecionada = paciente;
      this.dialogResumoPaciente = true;
    },
    async buscaUsuarios() {
      this.loading.usuarios = true;
      try {
        const response = await Requester.usuario.usuarios({
          grupo_id: [
            gruposIds.MÉDICAS,
            gruposIds.DIREÇÃO,
            gruposIds.OBSTETRIZES,
          ],
          ativo: 'true',
        });
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.usuarios = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.usuarios = false;
      }
    },
    async carregaNovaPagina(search) {
      this.loading.table = true;
      this.$emit('atualiza-loading', true);
      this.pacientes = [];
      // options tipo
      const queryObj: any = {
        pagina: this.options.page,
        itens_por_pagina: this.options.itemsPerPage,
        tipo: this.tipo,
        responsavel_id: this.filtroResponsavelId,
      };
      if (this.options.sortBy.length > 0) {
        [queryObj.sortBy] = this.options.sortBy;
        [queryObj.sortDesc] = this.options.sortDesc;
      }
      if (search.length > 0) {
        queryObj.search = search;
      }
      try {
        const response = await Requester.paciente.pacientes(queryObj);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.pacientes = response.data.registros;
          this.totalRegistros = response.data.total_registros;
          this.$emit('atualiza-total-registros', this.totalRegistros);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.table = false;
        this.$emit('atualiza-loading', false);
      }
    },
    novaPaciente(paciente) {
      this.pacientes.push(paciente);
    },
  },
  watch: {
    options: {
      handler() {
        this.carregaNovaPagina(this.search);
      },
      deep: true,
    },
  },
});
